
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSlipJournalItem extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public account: Common.Account = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.SlipJournalItemReportTemplateQuery = new Common.SlipJournalItemReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.startDate = new Date().getCalendarDate();
    this.startDate.setDate(1);
    this.endDate = new Date().getCalendarDate();
    this.endDate = new Date(this.endDate.getFullYear(),this.endDate.getMonth() + 1, 0);
    
    (this.$refs.SlipJournalItemDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SlipJournalItemReportQuery = new Common.SlipJournalItemReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.account = this.account;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
